const state = {
  changeTodo: false,
  changeAlarm: false,
  newTodo: {},
  newAlarm: {},
  calendartogglestate: false,
};

export default state;
